import { computed } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';

function useClinicianStreamsComposable({ remoteUserProps }) {
  const sessionStore = useSessionStore();

  const isHiddenConsultationStream = computed(
    () => sessionStore.isPutOnHold || sessionStore.isPhasePaused,
  );
  const isRemoteVideoOff = (clinicianId) => !remoteUserProps[clinicianId].video;

  /**
   * TODO: Massive refactoring (Security Concern as well)
   * Inside the GroupCallView, we use the SingleJitsiUser to handle displaying of
   * remote user streams. However that user is not displayed in the POC of the but added
   * to the conference to keep the functionality working. We may need a high level jitsi
   * user to handle addition of tracks to conference and move remoteUserProps to pinia.
   *
   * This updated condition simply filters out the single clinician user when multi camera
   * is enabled so that it doesn't appear as a black box on the participant's view during
   * CONSULTATION
   *
   * We definitely need a unique way of knowing who is a Clinician in such a way that someone
   * Cannot just register with that name and mess up the logic.
   *
   * Quick solution is to tie the displayName to the sessionId.
   *
   * Generally reliance on the displayName is a single point of failure for most of our logic.
   * It became necessary because onUserJoined, it becomes difficult to find a unique attribute
   * to distinguish users. We need some more research into it.
   *
   * Maybe no cause for alarm. We just make sure no participant can create a name with certain
   * keywords such as vuzix, stethoscope, Clinician during account creation
   */

  const isNotSingleClinicianCamera = (name) =>
    /Clinician/.test(name) &&
    (/Camera/.test(name) ||
      /Clinician/.test(name) ||
      /Webcam/.test(name) ||
      /ScreenshareUser/.test(name) ||
      /Stethoscope/.test(name));
  const isClinicianName = (name) => isNotSingleClinicianCamera(name);

  const isScreenshareUser = (name) => /ScreenshareUser/.test(name);
  return {
    isHiddenConsultationStream,
    isRemoteVideoOff,
    isClinicianName,
    isScreenshareUser,
  };
}

export default useClinicianStreamsComposable;
